const Const = {
    defaults: {
        title: 'Millennials Mafia',
        language_list: [
            {
                title: 'pt',
                path: 'pt-br'
            },
            {
                title: 'en',
                path: 'en-us'
            }
        ],
        default_lang: 'pt-br',
        base_url: 'https://api.millennialsmafia.com/v1/',
        url: "https://millennialsmafia.com",
        image_base_url: 'https://millennialsmafia.com/admin/imagens/'
    },
    hash: {
        cookie_lang: 'lang_millenials_cookies'
    }
}

module.exports = Const


// WEBPACK FOOTER //
// ./src/config/const.js